<div class="esf-spinner flex-container-loading" *ngIf="loading">
  <div class="row">
    <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
  </div>
</div>

<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened" *ngIf="!loading">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='Main heading for the customer profile component@@customerOverviewComponent.heading.campaignActivity' class="esf-action-heading__text">Campaign activity</span>
    </h1>

    <table class="esf-table"
           *ngIf="campaignActivity?.length"
           app-table
           [columns]="columns"
           [keys]="keys"
           [data]="campaignActivity"
           (rowClickEvent)="openCampaignPage($event)">
    </table>

    <table class="esf-table" *ngIf="!campaignActivity?.length">
      <section class="esf-empty-state flex-empty-state">
        <div>
          <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
            <use xlink:href="#esf-icon-megaphone"></use>
          </svg>
        </div>
        <p class="esf-paragraph">
          <small i18n='Text for empty state@@customerOverviewComponent.text.noCampaignActivity'>There is no campaign activity</small>
        </p>
      </section>
    </table>

  </div>
</main>
